import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import './ClaimInfo.css';
import TabPanel from '../TabPanel';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import CloseIcon from '@mui/icons-material/Close';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const Item = styled(Paper)(({ theme }) => ({
  boxShadow: 'none',
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const MyTab = styled(Tab)({
  fontFamily: 'Open Sans',
  fontWeight: '600',
  color: '#525252',
});

const ClaimInfo = (props) => {
  const [contactAttributes, setContactAttributes] = useState({});

  //Used to keep track of currently selected tab
  const [value, setValue] = React.useState(props.contactAttributes?.mostRecentClaimIndicator?.value === 'Navilink' ? 1 : 0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [open, setOpen] = React.useState(false);

  const handleToClose = (event, reason) => {
    if ('clickaway' === reason) return;
    setOpen(false);
  };

  const handleClickEvent = () => {
    setOpen(true);
  };

  useEffect(() => {
    if (props.contactAttributes) {
      setContactAttributes(props.contactAttributes);
    }
  }, [props]);

  return (
    <div>
      <p className="claimHeading fs-unmask">MOST RECENT CLAIM</p>
      <div style={{ marginLeft: '20px', marginRight: '20px' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >
            <MyTab label="Fineos" className={'test fs-unmask'} {...a11yProps(0)} />
            <MyTab label="Navilink" className={'test fs-unmask'} {...a11yProps(1)} />
            <MyTab label="Documents" className={'test fs-unmask'} {...a11yProps(2)} />
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <div id="fineosInfo">
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={6}>
                <Item>
                  <div style={{ float: 'left' }}>
                    <div id="label" className="label fs-unmask">
                      Claim ID
                      {contactAttributes.fineosClaimId &&
                      contactAttributes.fineosClaimId.value !== '' ? (
                        <ContentCopyIcon
                          sx={{
                            position: 'relative',
                            left: '5px',
                            ":hover": {
                              bgcolor: "white",
                              color: "#1976d2",
                              scale: "1.3"
                            }
                          }}
                          className="copyIcon"
                          style={{ width: '15px', height: '15px' }}
                          onClick={() => {
                            navigator.clipboard.writeText(
                              contactAttributes.fineosClaimId.value,
                            );
                            handleClickEvent();
                          }}
                        ></ContentCopyIcon>
                      ) : (
                        ''
                      )}
                      <Snackbar
                        anchorOrigin={{
                          horizontal: 'left',
                          vertical: 'bottom',
                        }}
                        open={open}
                        autoHideDuration={5000}
                        message="Copied."
                        onClose={handleToClose}
                        action={
                            <IconButton
                              size="small"
                              aria-label="close"
                              color="inherit"
                              onClick={handleToClose}
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                        }
                      />
                    </div>
                    <div id="data" className="data fs-unmask">
                      {contactAttributes?.fineosClaimId?.value || '-'}
                    </div>
                  </div>
                </Item>
              </Grid>
              <Grid item xs={6}>
                <Item>
                  <div style={{ float: 'left' }}>
                    <div id="label" className="label fs-unmask">
                      Leave ID
                      {contactAttributes.fineosLeaveId &&
                      contactAttributes.fineosLeaveId.value !== '' ? (
                        <ContentCopyIcon
                          sx={{
                            position: 'relative',
                            left: '5px',
                            ":hover": {
                              bgcolor: "white",
                              color: "#1976d2",
                              scale: "1.3"
                            }
                          }}
                          className="copyIcon"
                          style={{ width: '15px', height: '15px' }}
                          onClick={() => {
                            navigator.clipboard.writeText(
                              contactAttributes.fineosLeaveId.value,
                            );
                            handleClickEvent();
                          }}
                        ></ContentCopyIcon>
                      ) : (
                        ''
                      )}
                    </div>
                    <div id="data" className="data fs-unmask">
                      {contactAttributes?.fineosLeaveId?.value || '-'}
                    </div>
                  </div>
                </Item>
              </Grid>
            </Grid>
            <hr className="hr" />
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={6}>
                <Item>
                  <div style={{ float: 'left' }}>
                    <div id="label" className="label fs-unmask">
                      Leave Reason
                    </div>
                    <div id="data" className="data fs-unmask">
                      {contactAttributes?.fineosLeaveReason?.value || '-'}
                    </div>
                  </div>
                </Item>
              </Grid>
            </Grid>
          </div>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <div id="navilinkInfo">
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={12}>
                <Item>
                  <div style={{ float: 'left' }}>
                    <div id="label" className="label fs-unmask">
                      Claim ID
                      {contactAttributes.navilinkClaimId &&
                      contactAttributes.navilinkClaimId.value !== '' ? (
                        <ContentCopyIcon
                          sx={{
                            position: 'relative',
                            left: '5px',
                            ":hover": {
                              bgcolor: "white",
                              color: "#1976d2",
                              scale: "1.3"
                            }
                          }}
                          className="copyIcon"
                          style={{ width: '15px', height: '15px' }}
                          onClick={() => {
                            navigator.clipboard.writeText(
                              contactAttributes.navilinkClaimId.value,
                            );
                            handleClickEvent();
                          }}
                        ></ContentCopyIcon>
                      ) : (
                        ''
                      )}
                    </div>
                    <div id="data" className="data fs-unmask">
                      {contactAttributes?.navilinkClaimId?.value || '-'}
                    </div>
                  </div>
                </Item>
              </Grid>
            </Grid>
            <hr className="hr" />
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={12}>
                <Item>
                  <div style={{ float: 'left' }}>
                    <div id="label" className="label fs-unmask">
                      Product Type
                    </div>
                    <div id="data" className="data fs-unmask">
                      {contactAttributes?.navilinkProduct?.value || '-'}
                    </div>
                  </div>
                </Item>
              </Grid>
            </Grid>
            <hr className="hr" />
            <Grid
              container
              rowSpacing={1}
              columnSpacing={{ xs: 1, sm: 2, md: 3 }}
            >
              <Grid item xs={12}>
                <Item>
                  <div style={{ float: 'left' }}>
                    <div id="label" className="label fs-unmask">
                      Home Office Identifier
                    </div>
                    <div id="data" className="data fs-unmask">
                      {contactAttributes?.navilinkHomeOfficeIndicator?.value || '-'}
                    </div>
                  </div>
                </Item>
              </Grid>
            </Grid>
          </div>
        </TabPanel>
        <TabPanel value={value} index={2}>
          <div id="documents">
            {contactAttributes.docOneUrl &&
            contactAttributes.docOneUrl.value !== '' ? (
              <Grid
                container
                rowSpacing={0.5}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              >
                <Grid item xs={12}>
                  <Item>
                    <div style={{ float: 'left' }}>
                      <Link
                        href={contactAttributes.docOneUrl.value}
                        underline="hover"
                        color="#127CB7"
                        className="documentHeading fs-unmask"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {contactAttributes.docOneTitle.value}
                      </Link>
                    </div>
                  </Item>
                </Grid>
                <Grid item xs={6}>
                  <Item>
                    <div style={{ float: 'left' }}>
                      <div id="documentData" className="documentData fs-unmask">
                        {contactAttributes.docOneFineosType.value +
                          ': ' +
                          contactAttributes.docOneFineosId.value}
                      </div>
                    </div>
                  </Item>
                </Grid>
                <Grid item xs={6}>
                  <Item>
                    <div style={{ float: 'left' }}>
                      <div id="documentData" className="documentData fs-unmask">
                        {contactAttributes.docOneReceivedDate.value}
                      </div>
                    </div>
                  </Item>
                </Grid>
              </Grid>
            ) : (
              ''
            )}
            {contactAttributes.docTwoUrl &&
            contactAttributes.docTwoUrl.value !== '' ? (
              <Grid
                container
                rowSpacing={0.5}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              >
                <Grid item xs={12}>
                  <Item>
                    <div style={{ float: 'left' }}>
                      <Link
                        href={contactAttributes.docTwoUrl.value}
                        underline="hover"
                        color="#127CB7"
                        className="documentHeading fs-unmask"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {contactAttributes.docTwoTitle.value}
                      </Link>
                    </div>
                  </Item>
                </Grid>
                <Grid item xs={6}>
                  <Item>
                    <div style={{ float: 'left' }}>
                      <div id="documentData" className="documentData fs-unmask">
                        {contactAttributes.docTwoFineosType.value +
                          ': ' +
                          contactAttributes.docTwoFineosId.value}
                      </div>
                    </div>
                  </Item>
                </Grid>
                <Grid item xs={6}>
                  <Item>
                    <div style={{ float: 'left' }}>
                      <div id="documentData" className="documentData fs-unmask">
                        {contactAttributes.docTwoReceivedDate.value}
                      </div>
                    </div>
                  </Item>
                </Grid>
              </Grid>
            ) : (
              ''
            )}
            {contactAttributes.docThreeUrl &&
            contactAttributes.docThreeUrl.value !== '' ? (
              <Grid
                container
                rowSpacing={0.5}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              >
                <Grid item xs={12}>
                  <Item>
                    <div style={{ float: 'left' }}>
                      <Link
                        href={contactAttributes.docThreeUrl.value}
                        underline="hover"
                        color="#127CB7"
                        className="documentHeading"
                        target="_blank"
                        rel="noreferrer"
                      >
                        {contactAttributes.docThreeTitle.value}
                      </Link>
                    </div>
                  </Item>
                </Grid>
                <Grid item xs={6}>
                  <Item>
                    <div style={{ float: 'left' }}>
                      <div id="documentData" className="documentData fs-unmask">
                        {contactAttributes.docThreeFineosType.value +
                          ': ' +
                          contactAttributes.docThreeFineosId.value}
                      </div>
                    </div>
                  </Item>
                </Grid>
                <Grid item xs={6}>
                  <Item>
                    <div style={{ float: 'left' }}>
                      <div id="documentData" className="documentData fs-unmask">
                        {contactAttributes.docThreeReceivedDate.value}
                      </div>
                    </div>
                  </Item>
                </Grid>
              </Grid>
            ) : (
              ''
            )}
            <hr className="documentHr" />
          </div>
        </TabPanel>
      </div>
    </div>
  );
};

ClaimInfo.propTypes = {
  contactAttributes: PropTypes.shape({
    mostRecentClaimIndicator: PropTypes.shape({
      value: PropTypes.string,
    }),
    fineosClaimId: PropTypes.shape({
      value: PropTypes.string,
    }),
    fineosLeaveId: PropTypes.shape({
      value: PropTypes.string,
    }),
    fineosLeaveReason: PropTypes.shape({
      value: PropTypes.string,
    }),
    navilinkClaimId: PropTypes.shape({
      value: PropTypes.string,
    }),
    navilinkProduct: PropTypes.shape({
      value: PropTypes.string,
    }),
    navilinkHomeOfficeIndicator: PropTypes.shape({
      value: PropTypes.string,
    }),
    docOneUrl: PropTypes.shape({
      value: PropTypes.string,
    }),
    docOneTitle: PropTypes.shape({
      value: PropTypes.string,
    }),
    docOneFineosType: PropTypes.shape({
      value: PropTypes.string,
    }),
    docOneFineosId: PropTypes.shape({
      value: PropTypes.string,
    }),
    docOneReceivedDate: PropTypes.shape({
      value: PropTypes.string,
    }),
    docTwoUrl: PropTypes.shape({
      value: PropTypes.string,
    }),
    docTwoTitle: PropTypes.shape({
      value: PropTypes.string,
    }),
    docTwoFineosType: PropTypes.shape({
      value: PropTypes.string,
    }),
    docTwoFineosId: PropTypes.shape({
      value: PropTypes.string,
    }),
    docTwoReceivedDate: PropTypes.shape({
      value: PropTypes.string,
    }),
    docThreeUrl: PropTypes.shape({
      value: PropTypes.string,
    }),
    docThreeTitle: PropTypes.shape({
      value: PropTypes.string,
    }),
    docThreeFineosType: PropTypes.shape({
      value: PropTypes.string,
    }),
    docThreeFineosId: PropTypes.shape({
      value: PropTypes.string,
    }),
    docThreeReceivedDate: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
};

export default ClaimInfo;
